import { Navigate, useLocation } from 'react-router';
import { legacyPolicyPath } from './legacyPolicyPath';

export const LegacyPolicyRedirect = (): React.JSX.Element => {
  const { pathname, search, hash } = useLocation();
  return <Navigate to={`${legacyPolicyPath(pathname)}${search}${hash}`} replace />;
};
